import { useQuery } from "@tanstack/react-query";
import { Api } from "../openApi";
import { simpleDiagnoseStorage } from "../utils/storage";
import { useMemo } from "react";

export type IncomeProtectionInsuranceRankProps = {
  maxBudget?: number;
  order: number;
  age: number;
  sex: number;
  monthlyBenefit: number;
  cancelRepayment?: boolean;
  paymentExemption: boolean;
  underwritingEasing: boolean;
  intentionRecommendInsurance: boolean;
  livingNeeds?: boolean;
  paymentMinGuaranteeTerm?: number;
  baseCode?: string;
  onSuccess?: () => void;
};

export const useIncomeProtectionInsuranceRank = (
  params: IncomeProtectionInsuranceRankProps
) => {

  const { result: simpleDiagnose } = useMemo(
    () => simpleDiagnoseStorage.get(),
    []
  );

  return useQuery(
    ["getIncomeProtectionInsuranceRank", params],
    async () => {
      const { data } = await Api.getApiIncomeProtectionInsurancesRank(
        params.order,
        params.age,
        params.sex,
        params.monthlyBenefit,
        params.paymentExemption,
        params.underwritingEasing,
        params.intentionRecommendInsurance,
        params.maxBudget,
        params.cancelRepayment,
        params.livingNeeds,
        params.paymentMinGuaranteeTerm,
        params.baseCode,
        simpleDiagnose.diagnos_code
      );
      params.onSuccess && params.onSuccess();
      return data;
    },
    { enabled: false }
  );
};
